import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { primaryLinks, serviceLinks } from "./navLinks";

function navItemClass(active) {
  return `nav-link text-sm font-medium transition-colors ${
    active ? "text-cyan-400" : "text-gray-300 hover:text-white"
  }`;
}

export default function DesktopNav() {
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const isServicesActive = serviceLinks.some((l) => location.pathname === l.path);

  return (
    <>
      <div className="hidden lg:flex items-center gap-8">
        <Link
          to="/"
          data-testid="nav-link-home"
          className={navItemClass(location.pathname === "/")}
        >
          Home
        </Link>

        <div
          className="relative"
          onMouseEnter={() => setServicesOpen(true)}
          onMouseLeave={() => setServicesOpen(false)}
        >
          <button
            data-testid="nav-link-services"
            className={`${navItemClass(isServicesActive)} flex items-center gap-1`}
          >
            Services
            <ChevronDown
              size={14}
              className={`transition-transform ${servicesOpen ? "rotate-180" : ""}`}
            />
          </button>
          <AnimatePresence>
            {servicesOpen && (
              <motion.div
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 8 }}
                transition={{ duration: 0.15 }}
                className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 rounded-xl bg-gray-900 border border-gray-700 shadow-2xl overflow-hidden"
              >
                {serviceLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    data-testid={`nav-service-${link.path.slice(1)}`}
                    className={`block px-5 py-3 text-sm transition-colors ${
                      location.pathname === link.path
                        ? "text-cyan-400 bg-cyan-400/5"
                        : "text-gray-300 hover:text-white hover:bg-white/5"
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {primaryLinks
          .filter((l) => l.path !== "/")
          .map((l) => (
            <Link
              key={l.path}
              to={l.path}
              data-testid={l.testId}
              className={navItemClass(location.pathname === l.path)}
            >
              {l.name}
            </Link>
          ))}
      </div>

      <div className="hidden lg:block">
        <Link to="/contact">
          <Button data-testid="nav-cta-button" className="btn-primary text-white font-medium px-6">
            Get Started
          </Button>
        </Link>
      </div>
    </>
  );
}
